// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"styles_mapWrapper__gbHpj"};
module.exports.__checksum = "fdfbfef67f2f"